/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Who sees the v2 calling bar, and when. Pure, so the rules are tested on
 * their own (shell-v2/softphoneBar.test.js).
 *
 * Shown only to a user with a CALL_CENTER seat on a tenant whose telephony is
 * switched on and configured. Then:
 *  - an administrator can switch the bar off for everyone;
 *  - a user can hide it for themselves, if the administrator allows that;
 *  - it steps aside on the Call Console, which has its own full controls.
 * A call that is ringing or in progress always shows the bar, whatever the
 * switches say: hiding the bar must never hide a live call or an incoming one.
 */

export const CALL_CENTER_SEAT = "CALL_CENTER";

export function softphoneBarState({
  seats = [],
  settingsChecked = false,
  telephonyEnabled = false,
  settings = null,
  userHidden = false,
  inlineHostActive = false,
  callState = "idle",
}) {
  const hasSeat = Array.isArray(seats) && seats.includes(CALL_CENTER_SEAT);
  const usable = hasSeat && settingsChecked && telephonyEnabled;
  const barOn = settings?.softphone_bar_enabled !== false;
  const allowHide = settings?.softphone_allow_user_hide !== false;
  const hasCall = callState !== "idle";
  const ringing = callState === "ringing";

  let visible = false;
  if (usable) {
    if (inlineHostActive) visible = ringing;
    else if (hasCall) visible = true;
    else visible = barOn && !(allowHide && userHidden);
  }

  return {
    visible,
    usable,
    hasSeat,
    // The per-user switch is offered only where it means something.
    canHide: usable && barOn && allowHide,
    hiddenByUser: usable && barOn && allowHide && userHidden,
  };
}
